const CalendarDay = ( { date, items, top, left, width, height, currentMonth, selected, onMouseUp, onMouseDown, onMouseMove, onCopy, changed }) => {

  const style = { left, top, width, height }

const divItems = <div className="calendar-day-items">
    {items.map(i => <div key={i.id}>{i.start.substring(0, 5)}-{i.finish.substring(0, 5)}</div>)}
  </div>


  const divDate = <div className="calendar-day-date">{date.date()}<img src={selected ? "/images/copy-white.svg" : "/images/copy-green.svg"} alt="copy" onClick={() => onCopy(items)}/></div>
  
  return<div 
    className={`calendar-day ${currentMonth ? "calendar-month-current" : ""} ${selected ? "calendar-selected" : ""} ${changed ? "calendar-changed" : ""}`} 
    style={style} 
    onMouseUp={() => onMouseUp(date)}
    onMouseDown={() => onMouseDown(date)}
    onMouseMove={() => onMouseMove(date)}
  >
    {divItems}
    {divDate}
  </div>
}

export default CalendarDay;